module.exports = __webpack_public_path__ + "te21-06370684.webp";